<template>
  <div class="c-bubble" :class="isHidden ? 'hidden' : ''">
    <div class="c-bubble__overlay"></div>
    <div class="c-bubble__wrapper">
      <download-cloud class="c-bubble__icon"></download-cloud>
      <p class="c-bubble__text c-bubble__text--title">{{ $t(title) }}</p>
      <p class="c-bubble__text">{{ $t(text) }}</p>
      <button
        class="c-bubble__button"
        @click="close"
        :aria-label="`${$t('CLOSE_MESSAGE')}`">
        {{ $t(buttonText) }}</button>
    </div>
  </div>
</template>

<script>
import { mapActions  } from 'vuex'
import {UserDB} from '@/services/db'
import store from '@/store'
import DownloadCloud from '@/assets/svg/DownloadCloud'

let db = new UserDB()

export default {
  name: 'Bubble',

  components: {
    'download-cloud': DownloadCloud
  },

  props: {
    title: {
      type: String,
      default: 'WHILE_ONLINE_TITLE'
    },
    text: {
      type: String,
      default: 'WHILE_ONLINE'
    },
    buttonText: {
      type: String,
      default: 'GOT_IT'
    }
  },

  data() {
    return {
      isHidden: true
    }
  },

  methods: {
    close() {
      this.isHidden = true
      this.setBubbleAcceptance(this.isHidden)
    },

    ...mapActions({
      setBubbleAcceptance: 'userSettings/setBubbleAcceptance'
    })
  },

  async mounted() {
    let getBubble

    try {
      getBubble = await db.getBubbleAcceptance('bubbleAccepted')
    } catch(error) {
      getBubble = store.state.userSettings.bubbleAccepted
    }

    this.isHidden = getBubble
    this.setBubbleAcceptance(getBubble)
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/_vars.scss';
@import '@/assets/scss/_mixin.scss';

.c-bubble__overlay {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: $overlay;
  z-index: 999;
}

.c-bubble__wrapper {
  display: block;
  position: fixed;
  background: $orange;
  margin: 0 auto;
  top: calc(50vh - 150px);
  right: 0;
  left: 0;
  width: 305px;
  z-index: 1000;
  text-align: center;
  color: $white;
  padding: 15px;
  border-radius: 40px;
}

.c-bubble__wrapper:after {
  visibility: hidden;
  content: ' ';
  position: absolute;
  width: 0;
  height: 0;
  right: -17px;
  border-color: $orange transparent transparent transparent;
  border-top: 15px solid transparent;
  border-left: 20px solid $orange;
  border-bottom: 15px solid transparent;
}

.c-bubble__icon {
  width: 74px;
  height: auto;
}

.c-bubble__text {
  font-size: 12px;
  margin: .8em 0;
  line-height: 1.25;
}

.c-bubble__text--title {
  font-weight: bold;
  font-size: 20px;
}

.c-bubble__button {
  background: $white;
  padding: 0.5em 2em;
  border: 0;
  border-radius: 20px;
  color: $orange;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  height: 30px;
  min-width: 162px;
  &:hover {
    background: $white-hover-bubble;
  }

  @include a11yOutline();
}

.hidden {
  display: none;
}

@media screen and (min-width: 1366px) {
  .c-bubble__overlay {
    display: none;
  }
  .c-bubble__wrapper {
    position: absolute;
    margin: auto;
    left: -205px;
    top: auto;
    bottom: -3em;
    margin-left: 0;
    width: 180px;
  }
  .c-bubble__wrapper:after {
    visibility: visible;
    top: auto;
    bottom: 55px;
  }
  .c-bubble__icon {
    width: 43px;
  }
  .c-bubble__text {
    font-size: 12px;
  }
  .c-bubble__button {
    height: auto;
    min-width: auto;
  }
}
</style>
